<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div>
            <b-modal id="modal" :title="$t('modal.referral_note')" ref="referral-modal">
                <div class="row">
                    <div class="col-md-12">
                        <p class="mb-3">{{ modalContent }}</p>
                    </div>
                </div>
            </b-modal>
        </div>
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card properties-table">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">{{ $t('properties_list.View_Properties') }}</h4>
                    </div>
                    <div class="card-body">
                        <vue-good-table mode="remote" @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :pagination-options="{
                                enabled: true, dropdownAllowAll: false, perPageDropdown: [10, 20, 50, 100, 200], nextLabel: this.$t('pagination.next'),
                                prevLabel: this.$t('pagination.Previous'),
                                rowsPerPageLabel: this.$t('pagination.rowsPerPage'),
                                ofLabel: this.$t('pagination.of'),
                            }" :rows="rows" :columns="columns" :sort-options="{
                                enabled: false,
                            }">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'property_type'">
                                    <span> {{ $t('property_detail.' + props.row.property_type) }}</span>
                                </span>
                                <span v-if="props.column.field == 'city'">
                                    <span> {{ props.row["city" + currentLanguage] }}</span>
                                </span>
                              <!-- {{ props.row }} -->
                                <span v-if="props.column.field == 'address'">
                                    <span> {{ props.row["address" + currentLanguage] }}</span>
                                </span>
                                <span v-if="props.column.field == 'status'">
                                    <span v-if="props.row.approve === 0">{{ $t('invoice.pending') }}</span>
                                    <span v-else>{{ $t('property_detail.approved') }}</span>
                                </span>
                                <span v-if="props.column.field === 'action'" class="text-nowrap properties-btns">
                                    <b-button @click="propertyRating(props.row.id)"
                                        class="mr-1 star-btn">
                                        <!-- {{ $t('properties_list.Ratings') }} -->
                                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.5" d="M9.63417 1.64619L8.03406 6.56344C7.8928 6.99452 7.49095 7.28678 7.03794 7.28678H1.88689C0.871292 7.28678 0.449953 8.58489 1.27071 9.18159L5.37451 12.1651C5.73983 12.4305 5.89327 12.8981 5.75688 13.3268L4.17625 18.3341C3.87181 19.2986 4.97265 20.0901 5.79098 19.4983L10.0141 16.432C10.3819 16.1666 10.8787 16.1666 11.244 16.432L15.4672 19.4983C16.2855 20.0926 17.3863 19.2986 17.0819 18.3341L15.5013 13.3268C15.3649 12.8981 15.5207 12.4281 15.8836 12.1651L19.9874 9.18159C20.8082 8.58489 20.3868 7.28678 19.3713 7.28678H14.2202C13.7672 7.28678 13.3653 6.99452 13.2241 6.56344L11.624 1.64619C11.3098 0.681738 9.94592 0.681738 9.63174 1.64619H9.63417Z" fill="#F2B601"/>
                                            </svg>
                                            
                                    </b-button>
                                    <b-button @click="editProperty(props.row)"
                                        class="mr-1 edit-btn">
                                        <!-- {{ $t('properties_list.Edit') }} -->
                                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.4159 15.1255L1.8159 11.5255L0.795898 16.1455L5.4159 15.1255ZM6.1259 14.4155L14.0459 6.49547L10.4459 2.89547L2.5259 10.8155L6.1259 14.4155ZM12.6359 0.705469L11.1559 2.18547L14.7559 5.78547L16.2359 4.30547C16.5359 4.00547 16.5359 3.51547 16.2359 3.22547L13.7159 0.705469C13.4159 0.405469 12.9259 0.405469 12.6359 0.705469Z" fill="white"/>
                                            </svg>                                            
                                    </b-button>
                                    <b-button @click="calendar(props.row)" class="mr-1 calendar-btn">
                                        <!-- Calendar -->
                                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.5" d="M0.383789 18.0685C0.383789 18.9707 1.11622 19.7031 2.01845 19.7031H15.2356C16.1378 19.7031 16.8702 18.9707 16.8702 18.0685V8.01747H0.383789V18.0685ZM12.1094 10.7974C12.1094 10.5444 12.3125 10.3413 12.5655 10.3413H14.0637C14.3167 10.3413 14.5198 10.5444 14.5198 10.7974V12.2956C14.5198 12.5486 14.3167 12.7517 14.0637 12.7517H12.5655C12.3125 12.7517 12.1094 12.5486 12.1094 12.2956V10.7974ZM12.1094 15.4983C12.1094 15.2453 12.3125 15.0422 12.5655 15.0422H14.0637C14.3167 15.0422 14.5198 15.2453 14.5198 15.4983V16.9964C14.5198 17.2495 14.3167 17.4526 14.0637 17.4526H12.5655C12.3125 17.4526 12.1094 17.2495 12.1094 16.9964V15.4983ZM7.42514 10.7974C7.42514 10.5444 7.62823 10.3413 7.88125 10.3413H9.37941C9.63243 10.3413 9.83552 10.5444 9.83552 10.7974V12.2956C9.83552 12.5486 9.63243 12.7517 9.37941 12.7517H7.88125C7.62823 12.7517 7.42514 12.5486 7.42514 12.2956V10.7974ZM7.42514 15.4983C7.42514 15.2453 7.62823 15.0422 7.88125 15.0422H9.37941C9.63243 15.0422 9.83552 15.2453 9.83552 15.4983V16.9964C9.83552 17.2495 9.63243 17.4526 9.37941 17.4526H7.88125C7.62823 17.4526 7.42514 17.2495 7.42514 16.9964V15.4983ZM2.73757 10.7974C2.73757 10.5444 2.94065 10.3413 3.19367 10.3413H4.69183C4.94486 10.3413 5.14794 10.5444 5.14794 10.7974V12.2956C5.14794 12.5486 4.94486 12.7517 4.69183 12.7517H3.19367C2.94065 12.7517 2.73757 12.5486 2.73757 12.2956V10.7974ZM2.73757 15.4983C2.73757 15.2453 2.94065 15.0422 3.19367 15.0422H4.69183C4.94486 15.0422 5.14794 15.2453 5.14794 15.4983V16.9964C5.14794 17.2495 4.94486 17.4526 4.69183 17.4526H3.19367C2.94065 17.4526 2.73757 17.2495 2.73757 16.9964V15.4983ZM15.2356 3.34987H13.531V2.2146C13.531 1.50214 12.9517 0.922852 12.2392 0.922852C11.5268 0.922852 10.9475 1.50214 10.9475 2.2146V3.34987H6.30652V2.2146C6.30652 1.50214 5.72723 0.922852 5.01477 0.922852C4.30231 0.922852 3.72302 1.50214 3.72302 2.2146V3.34987H2.01845C1.11622 3.34987 0.383789 4.08231 0.383789 4.98453V6.8589H16.8735V4.98453C16.8735 4.08231 16.1411 3.34987 15.2389 3.34987H15.2356Z" fill="#70D3FF"/>
                                            </svg>                                            
                                    </b-button>
                                    <b-button @click="deleteProperty(props.row.id)"
                                        class="mr-1 delete-btn">
                                        <!-- {{ $t('properties_list.Delete') }} -->
                                        <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path opacity="0.5" d="M13.7483 3.50285H9.41832V2.72285C9.41832 1.73285 8.60832 0.922852 7.61832 0.922852C6.62832 0.922852 5.81832 1.73285 5.81832 2.72285V3.50285H1.49832C0.82832 3.50285 0.27832 4.04285 0.27832 4.72285C0.27832 5.40285 0.81832 5.94285 1.49832 5.94285H13.7583C14.4283 5.94285 14.9783 5.39285 14.9783 4.72285C14.9783 4.05285 14.4283 3.50285 13.7583 3.50285H13.7483ZM1.41832 17.5029C1.41832 18.7229 2.40832 19.7029 3.61832 19.7029H11.6183C12.8383 19.7029 13.8183 18.7129 13.8183 17.5029V7.31285H1.41832V17.5029ZM8.78832 10.2529C8.78832 9.83285 9.12832 9.49285 9.54832 9.49285C9.96832 9.49285 10.3083 9.83285 10.3083 10.2529V16.7229C10.3083 17.1429 9.96832 17.4829 9.54832 17.4829C9.12832 17.4829 8.78832 17.1429 8.78832 16.7229V10.2529ZM4.93832 10.2529C4.93832 9.83285 5.27832 9.49285 5.69832 9.49285C6.11832 9.49285 6.45832 9.83285 6.45832 10.2529V16.7229C6.45832 17.1429 6.11832 17.4829 5.69832 17.4829C5.27832 17.4829 4.93832 17.1429 4.93832 16.7229V10.2529Z" fill="#FF4747"/>
                                            </svg>                                            
                                    </b-button>
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </div>
        <div></div>
    </section>
</template>

<script>
import Vue, { set } from "vue";
import SortedTablePlugin from "vue-sorted-table";
import API from '@/api'
import moment from 'moment'

Vue.use(SortedTablePlugin, {
    ascIcon: '<i class="ti-arrow-down"></i>',
    descIcon: '<i class="ti-arrow-up"></i>'
});
export default {
    name: 'Spotters',
    data() {
        return {
            searchTime: null,
            isDisabled: false,
            referralNote: 'Referral Note',
            modalContent: '',
            currentLanguage: '',
            selected: true,
            unSelected: false,
            serverParams: {
                search: "",
                sort: [
                    {
                        field: 'UserID', // example: 'name'
                        type: 'desc' // 'asc' or 'desc'
                    }
                ],
                page: 1, // what page I want to show
                perPage: 10 // how many items I'm showing per page
            },
            columns: [
                {
                    label: 'Property Type',
                    field: 'property_type',
                    filterable: false,
                },
                {
                    label: 'City',
                    field: 'city',
                    sortable: false,
                },
             
                {
                    label: 'Address',
                    field: "address",
                    sortable: false,
                },
                {
                    label: 'Status',
                    field: "status",
                    sortable: false,
                },
                {
                    label: 'Action',
                    field: "action",
                    sortable: false,
                },
            ],
            isLoading: false,
            rows: [],
            totalRecords: 0,
            spots: [],
            ReferredBy: new Map(),
            form: {
                ReferredID: '',
            },
        };
    },
    methods: {
        updateColumnLabels() {
            this.columns.forEach(col => {
                switch (col.field) {
                    case 'property_type':
                        col.label = this.$t('properties_list.Property_Type');
                        break;
                    case 'city':
                        col.label = this.$t('properties_list.city');
                        break;
                  
                    case 'address':
                        col.label = this.$t('properties_list.address');
                        break;
                    case 'status':
                        col.label = this.$t('property_detail.Status');
                        break;
                    case 'action':
                        col.label = this.$t('properties_list.action');
                        break;
                    default:
                        break;
                }
            });
        },
        onLanguageChanged(language) {
            if (language == 'en') {
                this.currentLanguage = '';
            } else {
                this.currentLanguage = '_' + language;
            }

        },
        editProperty(property) {
            this.$router.push({ name: 'add_property', params: { id: property.id, data: property } });
        },
        calendar(property) {
            this.$router.push({ name: 'Calendar', params: { id: property.id, data: property } });
        },
        propertyRating(id) {
            this.$router.push({ name: 'view_rating', params: { id: id } });
        },
        deleteProperty(id) {
            this.$swal({
                title: this.$t('sweetalert.Are_you_sure?'),
                text: this.$t('sweetalert.no_revert'),
                type: 'warning',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('sweetalert.yes'),
                cancelButtonText: this.$t('sweetalert.cancel')
            }).then((result) => {
                if (result.value == true) {
                    API.deleteProperty(id, res => {
                        this.loadItems();
                    }, err => {
                        console.log(err);
                    })
                }
            })
        },
        openReferralModal(row) {
            this.modalContent = row.ReferralNotes;
            this.$refs['referral-modal'].show();
        },
        editMemberStatuss() {
            API.updateRefMemberStatus(this.form,
                data => {
                    this.isDisabled = false;
                    if (data.status === 200) {
                        this.$showNotification(data, "success")
                        this.loadItems();
                    } else {
                        this.errorMsg('Please try again.')
                    }
                },
                err => {
                    this.isDisabled = false;
                    this.errorMsg(err)
                }
            )
        },
        dateFormat(val) {
            return moment(val).format('DD MMMM YYYY')
        },
        loadItems() {
            API.getProperties(this.serverParams,
                data => {
                    this.totalRecords = data.totalRecords;
                    this.rows = data.data;
                    this.isLoading = false;
                }, err => {
                    console.log(err)
                    this.isLoading = false;
                })
        },
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        }
    },
    computed: {
        propertytype() {
            return this.$t('properties_list.Property_Type');
        },
        action() {
            return this.$t('properties_list.action');
        },
        city() {
            return this.$t('properties_list.city');
        },
        state() {
            return this.$t('properties_list.state');
        },
    },
    mounted() {
        this.isLoading = true;
        Vue.prototype.$EventBus.$on('changeLanguage', this.updateColumnLabels);
        this.loadItems();
        this.updateColumnLabels();
    },
    watch: {
        '$i18n.locale': function (newLocale, oldLocale) {
            this.columns.find(col => col.field === 'property_type').label = this.propertytype;
            this.columns.find(col => col.field === 'action').label = this.action;
            this.columns.find(col => col.field === 'city').label = this.city;
            // this.columns.find(col => col.field === 'state').label = this.state;
        }
    }
}
</script>